export default __webpack_public_path__ + "static/loader-93684ab2f36fe18efe25d664a477f3d7.gif";